import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import ScrollTopButton from '@/components/feature/ScrollTopButton';

export default function Home() {
  const { t } = useTranslation();

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: t('site.name'),
    url: 'https://www.benziwz.com/',
    description: t('site.description'),
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.benziwz.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: t('site.name'),
    url: 'https://www.benziwz.com/',
    description: t('site.description'),
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@benziwz.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '本子网站是什么？', acceptedAnswer: { '@type': 'Answer', text: '本子网站是一个专为二次元爱好者打造的正版漫画在线阅读平台，提供海量日系漫画、同人志和原创本子内容。我们致力于提供高品质、正版的阅读体验，支持高清浏览、分类检索和收藏管理。' } },
      { '@type': 'Question', name: '如何注册成为会员？', acceptedAnswer: { '@type': 'Answer', text: '点击网站右上角的"注册"按钮，填写邮箱地址和设置密码即可完成注册。注册后即可免费体验平台上的所有内容，无需支付任何费用。' } },
      { '@type': 'Question', name: '本子网站上的漫画都是正版的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，本子网站上的所有漫画内容均经过正版授权。我们与多家日本出版社和独立创作者建立了合作关系，确保所有内容均为合法授权的正版作品。' } },
      { '@type': 'Question', name: '支持哪些设备阅读？', acceptedAnswer: { '@type': 'Answer', text: '本子网站支持PC端、平板和手机端浏览。无论你使用什么设备，都能享受高清流畅的阅读体验。推荐使用Chrome或Safari浏览器获得最佳效果。' } },
      { '@type': 'Question', name: '如何收藏喜欢的漫画？', acceptedAnswer: { '@type': 'Answer', text: '登录后，在漫画详情页点击"收藏"按钮即可将该漫画加入你的收藏列表。你可以随时在个人中心查看和管理你的收藏。' } },
      { '@type': 'Question', name: '更新频率是怎样的？', acceptedAnswer: { '@type': 'Answer', text: '我们与创作者保持紧密合作，确保漫画更新及时。大部分连载作品每周更新1-2话，已完结作品可直接阅读全部章节。你可以在首页"最新更新"区域查看最近更新的作品。' } },
    ],
  };

  return (
    <>
      <SEO
        title={`${t('site.name')} - ${t('site.slogan')}`}
        description={t('site.description')}
        canonical="https://www.benziwz.com/"
        jsonLd={[websiteSchema, organizationSchema, faqSchema]}
      />
      <main>
        <Navbar />
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FaqSection />
        <CtaSection />
        <Footer />
        <ScrollTopButton />
      </main>
    </>
  );
}